import { ComplexEntityManagerComponent } from "ng/src/app/core/complex-entity-manager/complex-entity-manager.component";
import { Report } from "ng/src/app/reports/report.model";
import { Component, Injector } from "@angular/core";
import { GeneralParameters } from "app/shared/model/request-parameter.model";
import { Observable } from "rxjs";
import { ReportService } from "ng/src/app/reports/report.service";

@Component({
	selector: 'lb-report-version-manager',
	templateUrl: '../../core/complex-entity-manager/complex-entity-manager.component.html',
	styleUrls: ['../../core/complex-entity-manager/complex-entity-manager.component.scss']
})
export class ReportComplexManagerComponent extends ComplexEntityManagerComponent<Report> {
	
	constructor(
		private reportService: ReportService,
		injector: Injector
	) {
		super(injector);
	}
	
	protected performQuery(query: GeneralParameters): Observable<Report[]> {
		return this.reportService.fetch(query);
	}
	
	getName(obj: Report): string {
		return obj.name;
	}
	
	protected performDelete(obj: Report): Observable<any> {
		return this.reportService.deleteReport(obj);
	}
	
	protected performPatch(obj: Report, update: any): Observable<any> {
		return this.reportService.patchReport(obj, update);
	}
}